<div mat-dialog-content>
  <lemon-dialog-header> Lähetä aineisto asiakkaalle ladattavaksi </lemon-dialog-header>

  <div>
    <div style="text-align: center; margin: 15px 0px">
      Asiakkaan yhteyshenkilöille lähetetään sähköpostitse linkki, jonka kautta aineisto on ladattavissa 1kk ajan. Aineiston lataaminen vaatii yhteyshenkilöltä tunnistautumisen pankkitunnuksilla. Aineiston lataamisen jälkeen yhteyshenkilöä pyydetään kuittaamaan, että aineisto on ladattu onnistuneesti. Kuittaus tallentuu automaattisesti järjestelmään.
      <br />
      <br />
      Mikäli latausta ei suoriteta viikon sisällä linkin lähettämisestä, yhteyshenkilöitä muistutetaan SMS-viestillä. Muistutus toistetaan 3 kertaa.
    </div>

    <div style="text-align: center; font-weight: bold; margin: 5px 0px">Aineisto lähetetään käyttäjille:</div>

    <div style="display: flex; flex-direction: column; align-items: center; margin: 15px 0px">
      <form>
        @for (valinta of lomake.vastaanottajat; track valinta; let i = $index) {
          <div>
            <mat-checkbox [formField]="valinta"> {{ data.vastaanottajat[i].etunimi }} {{ data.vastaanottajat[i].sukunimi }} ({{ data.vastaanottajat[i].email }}) </mat-checkbox>
          </div>
        }
        @if (onkoVirhe(lomake.vastaanottajat, 'min')) {
          <div class="lemon-error">Ole hyvä ja valitse vähintään yksi vastaanottaja</div>
        }
      </form>
    </div>

    <div style="text-align: center; font-weight: bold; margin: 5px 0px">Sähköpostin sisältö</div>

    <pre style="white-space: pre-line; text-align: left; margin: 15px 0px">
          {{ data.sahkopostinTeksti }}
        </pre>
  </div>
  <div mat-dialog-actions style="padding-left: 0; padding-right: 0; justify-content: space-around; justify-content: space-evenly">
    <app-secondary-button (click)="peruuta()" mat-dialog-close actionId="Peruuta aineiston lähettäminen (dialog)">Peruuta</app-secondary-button>
    <app-primary-button (click)="laheta()" [disabled]="lomake().invalid()" actionId="Hyväksy aineiston lähettäminen (dialog)" [actionContext]="[]">Lähetä aineisto</app-primary-button>
  </div>
</div>
